import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PopUp from "../../components/PopUp";
import Input from "../../components/Input";
import TempStorage from "../../components/Storage";
import Alert from "../../components/Alert";
import { useDarkMode } from "../../components/DarkModeContext";
import { PanelLeftOpen, PanelLeftClose, House, Cog, User, LogOut, SunMoon, UserPen, KeyRound } from "lucide-react";

let infoUtente = {};

const NavbarDev = ({ page }) => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [isProfiloOpen, setIsProfiloOpen] = useState(false);
    const [isChangePasswordOpen, setIsChangePasswordOpen] = useState(false);
    const [isEditProfileOpen, setIsEditProfileOpen] = useState(false);
    const [nome, setNome] = useState(infoUtente["Nome"] || null);
    const [cognome, setCognome] = useState(infoUtente["Cognome"] || null);
    const [email, setEmail] = useState(infoUtente["Email"] || null);
    const [vecchiaPassword, setVecchiaPassword] = useState("");
    const [nuovaPassword, setNuovaPassword] = useState("");
    const [confermaPassword, setConfermaPassword] = useState("");
    const { darkMode, toggleDarkMode } = useDarkMode();
    const navigate = useNavigate();
    const [showAlert, setShowAlert] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ type: "info", text: "", onClose: () => setShowAlert(false), needConfirm: false, onConfirm: () => { } });

    const toggleDrawer = () => {
        setIsDrawerOpen(!isDrawerOpen);
    };

    const handleLogout = () => {
        document.cookie.split(";").forEach(cookie => {
            const name = cookie.split("=")[0].trim();
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
        });
        navigate('/');
    };

    const checkEmail = async () => {
        if (email === "" || email === infoUtente["Email"]) return;

        try {
            const r = await fetch('/checkEmail', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ Email: email }),
            });
            if (r.status === 500) {
                const rd = await r.json();
                console.log(rd.error);
                setAlertInfo({ type: "error", text: rd.error, onClose: () => setShowAlert(false), needConfirm: false });
                setShowAlert(true);
                setEmail(infoUtente['Email']);
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore durante il controllo dell'email", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
        }
    };

    const confirmPopUpProfilo = async () => {
        try {
            const r = await fetch('/aggiornaUtente', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ ID: infoUtente['ID'], Nome: nome, Cognome: cognome, Email: email })
            });

            if (r.status === 500) {
                const rd = await r.json();
                console.log(rd.error);
                setAlertInfo({ type: "error", text: rd.error, onClose: () => setShowAlert(false), needConfirm: false });
                setShowAlert(true);
            }
            else {
                window.location.reload();
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore durante l'aggiornamento del profilo", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
        }
    };

    const checkPassword = (password) => {
        let check = true;
        const uppercasePattern = /[A-Z]/;
        const lowercasePattern = /[a-z]/;
        const specialCharPattern = /[!@#$%^&*(),.?":{}|<>]/;
        const numberPattern = /[0-9]/;

        if (!uppercasePattern.test(password)) {
            check = false;
        }
        if (!lowercasePattern.test(password)) {
            check = false;
        }
        if (!specialCharPattern.test(password)) {
            check = false;
        }
        if (!numberPattern.test(password)) {
            check = false;
        }
        if (password.length < 8) {
            check = false;
        }

        return check;
    };

    const confirmPopUpPassword = async () => {
        //Contollo la vechia password
        try {
            const r = await fetch('/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ Email: infoUtente["Email"], Password: vecchiaPassword, CodiceDispositivo: "ignore" }),
            });
            const rd = await r.json();
            if (r.status === 500) {
                console.log(rd.error);
                setAlertInfo({ type: "error", text: rd.error, onClose: () => setShowAlert(false), needConfirm: false });
                setShowAlert(true);
                setVecchiaPassword('');
                return;
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore durante il controllo della vecchia password", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
            return;
        }

        //Controllo che la nuova password rispetti i requisiti
        if (!checkPassword(nuovaPassword)) {
            setAlertInfo({ type: "warning", text: "La nuova password non rispetta i requisiti", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
            setNuovaPassword('');
            setConfermaPassword('');
            return;
        }

        //Controllo che la nuova password e la conferma password siano uguali
        if (nuovaPassword !== confermaPassword) {
            setAlertInfo({ type: "warning", text: "La nuova password e la conferma password non sono uguali", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
            setNuovaPassword('');
            setConfermaPassword('');
            return;
        }

        //Confermo
        try {
            const r = await fetch('/aggiornaPassword', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ ID: infoUtente["ID"], Password: nuovaPassword }),
            });


            if (r.status === 200) {
                setIsChangePasswordOpen(false);
                setVecchiaPassword('');
                setNuovaPassword('');
                setConfermaPassword('');
            }
            else {
                const rd = await r.json();
                console.log(rd.error);
                setAlertInfo({ type: "error", text: rd.error, onClose: () => setShowAlert(false), needConfirm: false });
                setShowAlert(true);
                return;
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore durante l'aggiornamento della password", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
            return;
        }
    };

    return (
        <>
            {showAlert && <Alert type={alertInfo.type} text={alertInfo.text} onClose={alertInfo.onClose} needConfirm={alertInfo.needConfirm} onConfirm={alertInfo.onConfirm} />}
            <nav className="relative flex justify-between items-center bg-gray-200 dark:bg-neutral-800 py-1 px-4">
                <button
                    type="button"
                    onClick={toggleDrawer}
                    className="hover:cursor-pointer w-10"
                >
                    <PanelLeftOpen size={24} />
                </button>
                <div className="absolute left-1/2 transform -translate-x-1/2 font-semibold text-lg hover:cursor-pointer" onClick={() => window.location.reload()}>
                    {page}
                </div>
                <img
                    src={darkMode ? "/img/LogoLight.png" : "/img/LogoDark.png"}
                    className="flex justify-self-end h-12"
                    alt="Logo"
                />
            </nav>
            <div className={`fixed top-0 left-0 z-40 p-1 h-screen content-between grid overflow-y-auto transition-transform duration-300 ${isDrawerOpen ? "translate-x-0" : "-translate-x-full"} bg-gray-100 dark:bg-neutral-900 w-[50%] md:w-64`}>
                <div>
                    <div className="flex items-center justify-between p-3">
                        <h5
                            className="text-base font-semibold text-gray-500 dark:text-gray-400"
                        >
                            MANTEGO
                        </h5>
                        <button
                            type="button"
                            onClick={toggleDrawer}
                            className="ml-2 hover:cursor-pointer"
                        >
                            <PanelLeftClose size={24} />
                        </button>
                    </div>

                    <div className="flex flex-col mt-4">
                        <div className="flex justify-between items-center hover:cursor-pointer hover:bg-gray-200 dark:hover:bg-neutral-800 px-3 py-2 rounded-lg" onClick={() => navigate("/dev/dash")}>
                            <span className="">Dashboard</span>
                            <House size={20} className="text-blue-600" />
                        </div>
                        <div className="flex justify-between items-center hover:cursor-pointer hover:bg-gray-200 dark:hover:bg-neutral-800 px-3 py-2 rounded-lg" onClick={() => navigate("/dev/impostazioni")}>
                            <span className="">Impostazioni</span>
                            <Cog size={20} className="text-blue-600" />
                        </div>
                        <div className="flex justify-between items-center hover:cursor-pointer hover:bg-gray-200 dark:hover:bg-neutral-800 px-3 py-2 rounded-lg" onClick={async () => {
                            if (!infoUtente["Nome"] || !infoUtente["Cognome"] || !infoUtente["Email"]) {
                                await loadNav();
                            }
                            setIsProfiloOpen(true);
                        }}>
                            <span className="">Profilo</span>
                            <User size={20} className="text-blue-600" />
                        </div>
                    </div>
                </div>

                <div className="pb-4 pt-2 border-t border-gray-200 dark:border-neutral-700 grid grid-cols-1">
                    <div className="flex justify-between items-center hover:cursor-pointer hover:bg-gray-200 dark:hover:bg-neutral-800 px-3 py-2 rounded-lg" onClick={() => toggleDarkMode(true, infoUtente["ID"])}>
                        <span className="">Cambia tema</span>
                        <SunMoon size={20} className="text-blue-600" />
                    </div>
                    <button className="bg-red-600 hover:bg-red-700 text-white font-medium py-2 px-4 rounded-lg hover:cursor-pointer mt-2 mx-2 flex justify-center items-center active:scale-95 transition-all" onClick={() => handleLogout()}>
                        LOGOUT
                        <LogOut size={20} className="inline ml-2" />
                    </button>
                </div>
            </div >
            {
                isDrawerOpen && (
                    <div
                        className="fixed inset-0 z-30 bg-black bg-opacity-50"
                        onClick={toggleDrawer}
                    />
                )
            }
            <PopUp title="Profilo"
                isVisible={isProfiloOpen}
                setIsVisible={setIsProfiloOpen}
                needConfirm={false}
            >
                <>
                    <div className="flex flex-col items-center">
                        <div className="w-[80%] md:w-[70%] mt-3">
                            <p className="flex justify-between">
                                Nome :
                                <span className="font-semibold">{infoUtente["Nome"]}</span>
                            </p>
                            <p className="flex justify-between mt-1">
                                Cognome :
                                <span className="font-semibold">{infoUtente["Cognome"]}</span>
                            </p>
                            <p className="flex justify-between mt-1">
                                Email :
                                <span className="font-semibold">{infoUtente["Email"]}</span>
                            </p>
                        </div>
                    </div>
                    <div className="grid grid-cols-2 mt-2">
                        <button className="flex items-center justify-center border-2 border-blue-600 text-blue-600 hover:bg-gray-200 hover:dark:bg-neutral-800 font-medium py-2 px-4 rounded-lg mr-2 hover:cursor-pointer" onClick={() => {
                            setNome(infoUtente["Nome"]);
                            setCognome(infoUtente["Cognome"]);
                            setEmail(infoUtente["Email"]);
                            setIsEditProfileOpen(true);
                        }}>
                            MODIFICA PROFILO<UserPen size={20} className="inline ml-1" />
                        </button>
                        <button className="flex items-center justify-center border-2 border-blue-600 text-blue-600 hover:bg-gray-200 hover:dark:bg-neutral-800 font-medium py-2 px-4 rounded-lg mr-2 hover:cursor-pointer" onClick={() => setIsChangePasswordOpen(true)}>
                            CAMBIA PASSWORD <KeyRound size={20} className="inline ml-1" />
                        </button>
                    </div>
                </>
            </PopUp>
            <PopUp title="Modifica profilo"
                isVisible={isEditProfileOpen}
                setIsVisible={setIsEditProfileOpen}
                needConfirm={true}
                confirmAction={confirmPopUpProfilo}
                cancelAction={() => { setIsEditProfileOpen(false); setNome(infoUtente["Nome"]); setCognome(infoUtente["Cognome"]); setEmail(infoUtente["Email"]); }}
            >
                <>
                    <div className="flex flex-col items-center">
                        <div className="w-[80%] md:w-[70%] mt-3">
                            <Input
                                label="Nome *"
                                value={nome}
                                setValue={(e) => setNome(e)}
                                type="text"
                            />
                            <Input
                                label="Cognome *"
                                value={cognome}
                                setValue={(e) => setCognome(e)}
                                type="text"
                                classes="mt-2"
                            />
                            <Input
                                label="Email *"
                                value={email}
                                setValue={(e) => setEmail(e)}
                                type="text"
                                classes="mt-2"
                                blurAction={checkEmail}
                            />
                        </div>
                    </div>
                </>
            </PopUp>
            <PopUp title="Cambia password"
                isVisible={isChangePasswordOpen}
                setIsVisible={setIsChangePasswordOpen}
                needConfirm={true}
                confirmAction={confirmPopUpPassword}
                cancelAction={() => { setIsChangePasswordOpen(false); setVecchiaPassword(''); setNuovaPassword(''); setConfermaPassword(''); }}
            >
                <>
                    <div className="flex flex-col items-center">
                        <div className="w-[80%] md:w-[70%] mt-3">
                            <Input
                                label="Vecchia Password *"
                                type="password"
                                value={vecchiaPassword}
                                setValue={(e) => setVecchiaPassword(e)}
                            />
                            <Input
                                label="Nuova Password *"
                                type="password"
                                value={nuovaPassword}
                                setValue={(e) => setNuovaPassword(e)}
                                classes="mt-2"
                                info={true}
                                infotext='La password deve contenere almeno 8 caratteri, di cui almeno una lettera maiuscola, una minuscola, un numero e un carattere speciale ( es. !@#$%^&*(),.?":{}|<>)'
                                infopos={"l"}
                            />
                            <Input
                                label="Conferma Nuova Password *"
                                type="password"
                                value={confermaPassword}
                                setValue={(e) => setConfermaPassword(e)}
                                classes="mt-2"
                            />
                        </div>
                    </div>
                </>
            </PopUp>
        </>
    );
};

export const loadNav = async () => {
    const idUser = TempStorage.exists('tokenDev') ? TempStorage.get('tokenDev') : document.cookie.indexOf('tokenDev') !== -1 ? document.cookie.split('tokenDev=')[1].split(";")[0] : null;

    try {
        const r = await fetch('/getUser', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ IDUser: idUser }),
        });

        const rd = await r.json();

        if (r.status === 500) {
            console.log(rd.error);
            alert(rd.error);
        }
        else {
            infoUtente = rd[0];
        }

    } catch (error) {
        console.log(error);
        alert("Errore nell'operazione");
    }
};

export default NavbarDev;